<template>
  <section
    id="cargoDelivery"
  >
    <div class="row">
      <label class="label">
        Desi Bilgisi
      </label>
      <div>
        <input
          type="number"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          v-model="product.dimensionalWeight"
        >
      </div>
    </div>
    <div class="row">
      <label class="label">
        Sevkiyat Süresi
      </label>
      <div>
        <input
          type="number"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          :disabled="disableDeliveryPeriod"
          :class="{'is-invalid' : errors.has('deliveryPeriod')}"
          name="deliveryPeriod"
          v-validate="{ validDeliveryDuration: { deliveryPeriod, deliveryDuration: product.deliveryDuration } }"
          data-vv-as="Sevkiyat Adresi"
          v-model="product.deliveryDuration"
        >
        <div class="invalid-feedback">
          {{ errors.first('deliveryPeriod') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="label">
        Ürün Sevk Adresi
      </label>
      <div>
        <Select
          v-model="shipmentAddress"
          :options="getShipmentAddresses"
          @onClear="clearShipmentAddress"
          @onSelect="selectShipmentAddress"
        />
      </div>
    </div>
    <div class="row">
      <label class="label">
        Ürün İade Adresi
      </label>
      <div>
        <Select
          v-model="returningAddress"
          :options="getReturningAddresses"
          @onClear="clearReturningAddress"
          @onSelect="selectReturningAddress"
        />
      </div>
    </div>
  </section>
</template>
<script>
import supplierService from '@/services/supplier';
import Select from '@/components/Select';

export default {
  name: 'ProductCargoInfo',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Select,
  },
  data () {
    return {
      deliveryPeriod: {},
      returningAddress: {},
      returningAddresses: [],
      shipmentAddress: {},
      shipmentAddresses: [],
    };
  },
  computed: {
    getShipmentAddresses () {
      return this.shipmentAddresses;
    },
    getReturningAddresses () {
      return this.returningAddresses;
    },
    disableDeliveryPeriod () {
      return this.deliveryPeriod &&
          this.deliveryPeriod.minAgreedDeliveryTime &&
          this.deliveryPeriod.deliveryDeadlineTime &&
          this.deliveryPeriod.deliveryDeadlineTime === this.deliveryPeriod.minAgreedDeliveryTime;
    },
  },
  methods: {
    async getSupplierAddresses () {
      const addressTypes = {
        DELIVERY_ADDRESS: 'Sevkiyat Adresi',
        RETURN_ADDRESS: 'İade Adresi',
      };

      try {
        const response = await supplierService.getSupplierAddresses();
        response.forEach(address => {
          address = {
            ...address,
            id: address.legacyId || address.id,
            label: `${addressTypes[address.addressType]} (${address.legacyId || address.id})`,
            subLabel: address.addressLine,
          };
          if (address.addressType === 'DELIVERY_ADDRESS') {
            this.shipmentAddresses.push(address);
          } else if (address.addressType === 'RETURN_ADDRESS') {
            this.returningAddresses.push(address);
          }
        });
        this.shipmentAddress = this.shipmentAddresses.find(address => address.id === this.product.shipmentAddressId);
        if (!this.shipmentAddress) {
          this.shipmentAddress = this.shipmentAddresses.find(address => address.isDefault);
        }

        this.returningAddress = this.returningAddresses.find(address => address.id === this.product.returningAddressId);
        if (!this.returningAddress) {
          this.returningAddress = this.returningAddresses.find(address => address.isDefault);
        }
      } catch {}
    },

    async getSupplierDeliveryPeriod () {
      try {
        this.deliveryPeriod = await supplierService.getSupplierDeliveryPeriod();
        this.$emit('setDeliveryPeriod', this.deliveryPeriod);
        if (!this.product.deliveryDuration) {
          this.product.deliveryDuration = this.deliveryPeriod.agreedDeliveryTime;
        }
      } catch {}
    },
    async validate () {
      return this.$validator.validateAll();
    },
    selectReturningAddress (item) {
      this.$set(this.product, 'returningAddress', item);
    },
    clearReturningAddress () {
      this.returningAddress = {};
      this.$set(this.product, 'returningAddress', {});
    },
    selectShipmentAddress (item) {
      this.$set(this.product, 'shipmentAddress', item);
    },
    clearShipmentAddress () {
      this.shipmentAddress = {};
      this.$set(this.product, 'shipmentAddress', {});
    },
  },
  created () {
    this.getSupplierAddresses();
    this.getSupplierDeliveryPeriod();
  },
};
</script>
